function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1 copy 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640.85 686.71"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M319.33 41.05c-133.23 0-241.24 108-241.24 241.23a240.41 240.41 0 0064.42 164.09h353.64a240.37 240.37 0 0064.42-164.09c0-133.22-108-241.23-241.24-241.23zM168.76 177.56h27.75l44.29 145.58h-27.75zM240 411.6l71.21-234h27.75l-71.21 234zm170.17 0h-27.8L338.06 266h27.75l30.44 100 57.32-188.41h27.75z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M396.25 365.98l-30.44-100h-27.75l44.31 145.61 27.75.01 71.2-234.03h-27.75l-57.32 188.41zM196.51 177.56h-27.75l44.29 145.58h27.75l-44.29-145.58zM311.16 177.57L239.95 411.6h27.75l71.21-234.03h-27.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M78.09 282.28c0-133.22 108-241.23 241.24-241.23s241.24 108 241.24 241.23a240.37 240.37 0 01-64.42 164.09h37.51a267.62 267.62 0 0055.52-163.59C589.18 134.37 468.86 14 320.43 14S51.67 134.37 51.67 282.78a267.56 267.56 0 0055.53 163.59h35.31a240.41 240.41 0 01-64.42-164.09z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "21.67",
  y: "446.37",
  width: "597.51",
  height: "226.31",
  rx: "34.82",
  fill: "#d0a74e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.88 635.62h18.16V486.91h-18.16v148.71zM177.49 486.91h-24.28v17.66h24.28a33.07 33.07 0 010 66.13h-24.28v17.64h24.28a50.72 50.72 0 100-101.43M464.52 486.9a74.35 74.35 0 1074.36 74.34 74.43 74.43 0 00-74.36-74.34m0 131.17a56.82 56.82 0 1156.82-56.83 56.87 56.87 0 01-56.82 56.83M324.71 575.05c20.3-1.78 38.58-16.5 38.58-43.27 0-27.43-19.4-44.83-46.61-44.83h-23.44v16.51h21.21c17.62 0 29.66 11.6 29.66 28.32s-12 28.55-29.66 28.55h-21.21v16.28h11.84L343 635.72h21.86zM275.07 486.95H256.9v148.77h18.52v-.1h-.35V486.95z"
})));